<!-- 全局页脚 -->
<template>
  <div class="ele-text-center flex-row justify-center">
    <div class="ele-text-secondary">
      {{ $t('layout.footer.copyright') }}
    </div>
    <img src="@/assets/footer-logo.png" style="margin-top: 2px; margin-left: 5px" height="12" />
  </div>
</template>

<script>
  export default {
    name: 'PageFooter'
  }
</script>

<style lang="scss" scoped>
  .ele-text-center {
    height: var(--layout-footer-height);
  }
</style>
